import { render, staticRenderFns } from "./huadoswip.vue?vue&type=template&id=2ed457f4&scoped=true&"
import script from "./huadoswip.vue?vue&type=script&lang=js&"
export * from "./huadoswip.vue?vue&type=script&lang=js&"
import style0 from "./huadoswip.vue?vue&type=style&index=0&id=2ed457f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed457f4",
  null
  
)

export default component.exports